<template>
    <div class="page">
      <PageLoading v-if="loading"></PageLoading>
        <TipsHbrb ref="child"></TipsHbrb>
        <div class="mainBox">
          <div class="scoreBox">
            <img class="boxtitle" src="@/assets/images/guess/my-titlebg.png" alt="">
            <div class="boxtxt">我的积分</div>
            <span class="gradient-text">{{userInfo.pk_score?userInfo.pk_score:0}}</span>
          </div>

          <div class="scoreBox">
            <img class="boxtitle" src="@/assets/images/guess/my-titlebg.png" alt="">
            <div class="boxtxt">参与场次</div>
            <span class="gradient-text">{{userInfo.pk_times?userInfo.pk_times:0}}</span>
          </div>

          <div class="scoreBox">
            <img class="boxtitle" src="@/assets/images/guess/my-titlebg.png" alt="">
            <div class="boxtxt">助威场次</div>
            <span class="gradient-text">{{userInfo.pk_times?userInfo.pk_win:0}}</span>
          </div>

          
          <div class="scoreBox" @click="showMyprize()">
            <img class="boxtitle" src="@/assets/images/guess/my-titlebg.png" alt="">
            <div class="boxtxt">我的奖品</div>
            <span class="gradient-text">{{userInfo.luckyNum?userInfo.luckyNum:0}}</span>
          </div>

          <div class="mybg1">
            <img src="@/assets/images/guess/laba.png" alt="">
          </div>
          <div class="mybg2">
            <img src="@/assets/images/guess/zuqiu.png" alt="">
          </div>
          <div class="mybg3">
            <img src="@/assets/images/guess/lipin.png" alt="">
          </div>

          <div class="navBox">
            <div class="navTxt" @click="toIndex">
              <div class="icoBox"><img src="@/assets/images/guess/index_off.png" alt=""></div>
              <div class="icoTitle">首页</div>
            </div>
            <div class="navTxt" @click="toRank">
              <div class="icoBox"><img src="@/assets/images/guess/rank_off.png" alt=""></div>
              <div class="icoTitle">排行榜</div>
            </div>
            <div class="navTxt" @click="toMyCenter">
              <div class="icoBox"><img src="@/assets/images/guess/center_off.png" alt=""></div>
              <div class="icoTitle">我的</div>
            </div>
          </div>
          
        </div>

        <van-popup closeable close-icon="clear" class="prizeContect" v-model="showEdit">
          <div class="contectBox">
            <div class="boxtop">
              <img class="shouhuo_txt" src="@/assets/images/guess/shouhuo_txt.png" alt="">
            </div>
            <div class="boxcenter">
              <div class="contectInfo">
                <van-cell-group>
                  <van-form ref="contectForm" @submit="onSubmit">
                    
                    <van-field v-model="userInfo.nickname" name="nickname" label="" placeholder="请输入姓名" :rules="[{ required: true, message: '' }]">
                      <van-icon class="huodong" class-prefix="icon" slot="left-icon" name="renwu-ren" size="20"></van-icon>
                    </van-field>

                    <van-field v-model="userInfo.phone" name="phone" type="tel" label="" placeholder="请输入手机号" :rules="[{ required: true, message: '' }]">
                      <van-icon class="huodong" class-prefix="icon" slot="left-icon" name="zhengjian" size="20"></van-icon>
                    </van-field>

                    <van-field v-model="userInfo.address" name="address" label="" placeholder="请输入收货地址" :rules="[{ required: true, message: '' }]">
                      <van-icon class="huodong" class-prefix="icon" slot="left-icon" name="dingwei1" size="20"></van-icon>
                    </van-field>
                  </van-form>
                </van-cell-group>
              </div>
            </div>
            <div class="boxbottom">
              <img class="shouhuo_btn" src="@/assets/images/guess/shouhuo_btn.png" alt="" @click="subData()">
            </div>
          </div>
        </van-popup>

        <van-popup closeable close-icon="clear" class="prizeContect" v-model="myPrizeBox">
          <div class="contectBox">
            <div class="boxtop">
              <img class="shouhuo_txt" src="@/assets/images/guess/prize_txt.png" alt="">
            </div>
            <div class="boxcenter">
              <div class="prizeList">
                
               <div class="detailBox" v-for="(prize, index) in myPrizeList" :key="index">
                 <div class="prizeInfo">
                  <div class="prizeTitle">{{prize.prize_name}}</div>
                    <div class="prizeNum">1份</div>
                    <div class="viewNoBtn" v-if="prize.prize_type==0"></div>
                    <div class="viewBtn" v-if="prize.prize_type==1 || prize.prize_type==2" @click="showSncode=prize.sncode">查看</div><!--口令-->
                    <div class="viewNoBtn" v-if="prize.prize_type==6"></div><!--话费-->
                 </div>
                 <div class="sncode" v-if="(prize.prize_type==1 || prize.prize_type==2) && showSncode==prize.sncode"> 
                  <div class="sncodeTxt">{{prize.sncode}}</div>
                  <div class="copyBtn" @click="copyTxt(prize.sncode)">复制</div>
                 </div>
               </div>
              </div>
            </div>
            <div class="boxbottom">
              <img class="shouhuo_btn" src="@/assets/images/guess/prize_btn.png" alt="" @click="showCentect()">
            </div>
          </div>
        </van-popup>

    </div>


    
</template>

<script>
//纵览顶部提示栏及唤起app
import TipsHbrb from '@/components/TipsHbrb.vue'
import PageLoading from '@/components/PageLoading.vue'

import {reqUserInfo, reqMyPrize, reqEditContect} from '@/api/guess.js'
// import {reqArea} from '@/api/index2.js' //静态接口

import zonglan from '@/utils/cp-zonglan.js'

import bgimg from '@/assets/images/learn/mycenter.png';

//分享
import { wxShare } from '@/utils/wxshare-wes2.com.js'
import { Clipboard } from "v-clipboard";
import Cookies from 'js-cookie'

export default {
  mixins: [],
  components: {
    TipsHbrb, PageLoading
  },
  props: {},
  data () {
    return {
      showSncode:'',
      loading: true,
      bgimg:bgimg,
      bgcolor:'#e4f3fa',
      guessid:0,
      token:"",
      accountId:'',
      uniqueId:'',
      actInfo:"",
      userInfo:{},
      nickname:"",
      username:"",
      scoreAll:0,
      scoreMust:0,
      scoreComplete:0,
      getCert:false,
      showNotice:false,
      myPrizeBox:false,
      myPrizeList:[],
      showEdit:false,
      showZhengshu:false,
      showLoad:true, //证书加载状态

      personName:'',
      phone:'',
      idCard:'',
      address:'',
      company:'',
      passCode:'',
      showSelect: false,
      indexList: [],
      filterData:[], // 处理后的 待渲染数据      
      areaList:[],
      shareImg:"https://img2.hebnews.cn/img/home.53fe0d7.png",
      shareTitle:"",
      shareDesc:"", 
      style:{},
      explain:"",
      kefu:"",
    }
  },
  computed: {},
  watch: {},
  created () {
    this.guessid = this.$route.query.guessid;
    this.token = this.$store.state.token;
    this.accountId = this.$store.state.accountId;
    this.uniqueId = this.$store.state.uniqueId;
    this.actInfo = this.$store.state.actInfo;
    this.shareImg = this.$store.state.actInfo.share_logo;
    this.shareTitle = this.$store.state.actInfo.share_title;
    this.shareDesc = this.$store.state.actInfo.share_desc;
    this.style = this.$store.state.actInfo.style;
  },
  mounted() {
    this.getUserInfo();
  },
  methods: {
    copyTxt(val) {
      console.log(val);
      Clipboard.copy(val);
      this.$toast({
        icon: 'success',
        message: '复制成功'
      }); 
    },
    getUserInfo(){ 
      this.loading = true;
      reqUserInfo({guessid:this.guessid, hbrb_account_id:this.accountId, hbrb_unique_id:this.uniqueId}).then(res => {
        if(res.code==200) {
          this.loading = false;
          this.userInfo = res.data;

        } else {
          this.loading = false;
          this.$toast({
              icon: 'warning-o',
              message: res.msg
          });
        }
      }).catch(err => {
        this.$toast({
              icon: 'warning-o',
              message: err
          });
      }) 
    },
    getMyPrize() { 
      this.loading = true;
      reqMyPrize({guessid:this.guessid, hbrb_account_id:this.accountId, hbrb_unique_id:this.uniqueId}).then(res => {
        if(res.code==200) {
          this.loading = false;
          this.myPrizeList = res.data;

        } else {
          this.loading = false;
          this.$toast({
              icon: 'warning-o',
              message: res.msg
          });
        }
      }).catch(err => {
        this.$toast({
              icon: 'warning-o',
              message: err
          });
      }) 
    },

    showMyprize(){
      this.getMyPrize();
      this.myPrizeBox = true;
    },
    showCentect(){
      this.myPrizeBox = false;
      this.showEdit = true;
    },
    subData(){
      this.$refs.contectForm.submit();
    },
    async onSubmit(values) { //表单提交
      console.log('submit', values);

      this.loading = true;
      reqEditContect({...values,guessid:this.guessid,hbrb_account_id:this.accountId,hbrb_unique_id:this.uniqueId}).then(res => {
        if(res.code==200) {
          this.loading = false;
          console.log('res.data',res.data);
          this.showEdit = false;

          this.$toast({
            icon: 'passed',
            message: res.msg
          });

        } else {
          this.loading = false;
          this.$toast({
              icon: 'warning-o',
              message: res.msg
          });
        }
      }).catch(err => {
        this.$toast({
              icon: 'warning-o',
              message: err
          });
      }) 

    },
    toIndex(){
      this.$router.push({ path: '/index',query:this.$route.query })
    },
    toMyCenter(){
      console.log('00');
      
      this.$router.push({ path: '/mycenter',query:this.$route.query })
    },
    toRank(){
      this.$router.push({ path: '/rank',query:this.$route.query })
    },
  },
}
</script>
<style lang="scss" scoped>
  @import '@/assets/css/mycenter.scss';
</style>
